import {  useState, useEffect, useCallback } from "react";
import { IoChevronBack } from "react-icons/io5";
import { HiUser } from "react-icons/hi";
import { FiTrash2 } from "react-icons/fi";
import WarehouseModal from ".././customComponentsTable/WarehouseModal";
import CustomSelect from '../../../customComponents/CustomSelect';
import SupplierModal from ".././customComponentsTable/SupplierModal";
import axios from "axios";
import styles from "./ReturnPanel.module.css";
import { API_URL } from '../../../config/api';

const ReturnCreatePanel = ({ warehouse, refundId, supplier, onClose, onSuccess }) => {

  const token = localStorage.getItem("token");
  const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(warehouse);
  const [isSupplierModalOpen, setIsSupplierModalOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [isFinishModalOpen, setIsFinishModalOpen] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [searchValue, setSearchValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const [tableRows, setTableRows] = useState([]);
  const [wallets, setWallets] = useState([]);

  useEffect(() => {
    if (supplier) {
      setSelectedSupplier(supplier);
    }
  }, [supplier]);

  useEffect(() => {
    if (!refundId || !selectedWarehouse || !token) return;

    const fetchRefundItems = async () => {
      try {
        // 1) Получаем все товары возврата
        const resItems = await axios.get(
          `${API_URL}/api/stock_changes/${refundId}/items`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const refundItems = resItems.data.data || [];

        // 2) Получаем все товары со склада, чтобы сопоставить названия
        const resStocks = await axios.get(
          `${API_URL}/api/stocks`,
          { 
            headers: { Authorization: `Bearer ${token}` },
            params: { storage_id: selectedWarehouse.id }
          }
        );

        const stocks = resStocks.data.data || [];

        // 3) Формируем строки таблицы
        const rows = refundItems.map((item) => {
          const stockInfo = stocks.find(s => s.product_id === item.product_id) || {};
          return {
            ...item,
            name_ru: stockInfo.name_ru || "—",
            ntin: stockInfo.ntin || "—",
            quantity: Number(item.quantity),
            purchase_price: Number(item.purchase_price || 0),
            stockQuantity: Number(stockInfo.quantity || 0),
          };
        });

        setTableRows(rows);
      } catch (err) {
        console.error("Ошибка загрузки товаров возврата:", err);
      }
    };

    fetchRefundItems();
  }, [refundId, selectedWarehouse, token]);


  const fetchWallets = useCallback(async () => {
    if (!selectedWarehouse?.id) return;
    try {

      const resCash = await axios.get(
        `${API_URL}/api/wallets?storage_id=${selectedWarehouse.id}&type=cash`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const resCard = await axios.get(
        `${API_URL}/api/wallets?type=card`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const walletsData = [...(resCash.data?.data || []), ...(resCard.data?.data || [])];

      const formattedWallets = walletsData.map(w => ({
        value: w.id,
        label: w.type === "card"
          ? `${w.bank_name || "Без банка"} - ${parseFloat(w.balance || 0).toLocaleString()} ₸`
          : `${w.storage || "Без склада"} - ${parseFloat(w.balance || 0).toLocaleString()} ₸`,
      }));

      setWallets(formattedWallets);
    } catch (err) {
      console.error("Ошибка загрузки wallets:", err);
      setWallets([]);
    } 
  }, [selectedWarehouse, token]);

  useEffect(() => {
    fetchWallets();
  }, [fetchWallets]);


  const submitReturn = async () => {
    if (!selectedWallet) {
      alert("Выберите кошелек!");
      return;
    }

    const payload = {
      type: "return",
      status: "approved",
      storage_id: selectedWarehouse.id,
      contractor_id: selectedSupplier ? selectedSupplier.id : null,
      quantity: tableRows.reduce((sum, r) => sum + r.quantity, 0),
      amount: totalPrice,
      wallet_id: selectedWallet.id,
      aux: { comment },
      items: tableRows.map((r) => ({
        product_id: r.product_id,
        quantity: r.quantity,
      })),
    };

    try {
      setIsSubmitting(true);

      // ✅ ESLint fix: res убрали
      await axios.post(`${API_URL}/api/stock_changes`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setIsFinishModalOpen(false);
      setTableRows([]);
      setSelectedSupplier(null);
      setSelectedWallet(null);
      setComment("");

      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.error("Ошибка отправки:", err);
      alert("Ошибка при отправке возврата!");
    } finally {
      setIsSubmitting(false);
    }
  };



  const handleFinishClick = () => {
    if (!selectedSupplier) {
      alert("Сначала выберите поставщика!");
      return;
    }

    if (tableRows.length === 0) {
      alert("Добавьте хотя бы один товар!");
      return;
    }

    setIsFinishModalOpen(true);
  };


  const handleWarehouseSelect = (wh) => {
    setSelectedWarehouse(wh);
    setIsWarehouseModalOpen(false);
  };

  useEffect(() => {
    if (!selectedWarehouse || !token) return;
    if (searchValue.trim().length < 3) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      try {
        const [byName, byNtin] = await Promise.all([
          axios.get(`${API_URL}/api/stocks`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              storage_id: selectedWarehouse.id,
              name_ru: searchValue,
            },
          }),
          axios.get(`${API_URL}/api/stocks`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              storage_id: selectedWarehouse.id,
              ntin: searchValue,
            },
          }),
        ]);

        const combined = [...byName.data.data, ...byNtin.data.data];

        const unique = combined.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.product_id === item.product_id)
        );

        setSuggestions(unique);
        setShowSuggestions(true);
      } catch (err) {
        console.error("Ошибка поиска:", err);
      }
    };

    const delay = setTimeout(fetchSuggestions, 400);
    return () => clearTimeout(delay);
  }, [searchValue, selectedWarehouse, token]);

  const handleSelect = async (item) => {
    setSearchValue("");
    setShowSuggestions(false);

    if (tableRows.some((r) => r.product_id === item.product_id)) return;

    try {
      const res = await axios.get(`${API_URL}/api/stock_change_items`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          storage_id: selectedWarehouse.id,
          product_id: item.product_id,
          is_used: false,
        },
      });

      const batches = [...res.data.data].sort((a, b) => a.id - b.id);

      const purchasePrice = batches.length > 0 ? Number(batches[0].purchase_price) : 0;
      const stockQuantity = batches.reduce((sum, b) => sum + Number(b.quantity), 0); // суммируем остаток

      const newRow = {
        ...item,
        quantity: 1,
        unit: item.measure_unit_id,
        purchase_price: purchasePrice,
        stockQuantity, // <-- добавили
        batches,
      };

      setTableRows((prev) => [...prev, newRow]);
    } catch (err) {
      console.error("Ошибка загрузки партий:", err);
    }
  };



  const handleQuantityChange = (productId, value) => {
    setTableRows((prev) =>
      prev.map((row) =>
        row.product_id === productId
          ? { ...row, quantity: Number(value) }
          : row
      )
    );
  };

  const removeRow = (id) => {
    setTableRows((prev) => prev.filter((row) => row.product_id !== id));
  };

  const totalPrice = tableRows.reduce(
    (sum, row) => sum + row.purchase_price * (row.quantity || 0),
    0
  );


  return (
    <div className={styles.container}>
      <div className={styles.topBar}>
        <button className={styles.backBtn} onClick={onClose}>
          <IoChevronBack size={22} />
        </button>
        <span className={styles.title}>Создание возврата</span>
      </div>

      <div className={styles.infoRow}>
        <div className={styles.infoCard}>
          <p className={styles.infoLabel}>Склад</p>
          <p className={styles.infoValue}>{selectedWarehouse.name}</p>
          <button
            className={styles.changeBtn}
            onClick={() => setIsWarehouseModalOpen(true)}
          >
            изменить
          </button>
        </div>

        <WarehouseModal
          isOpen={isWarehouseModalOpen}
          onClose={() => setIsWarehouseModalOpen(false)}
          onSelect={handleWarehouseSelect}
        />

        <div
          className={styles.infoCard}
          onClick={() => setIsSupplierModalOpen(true)}
          style={{ cursor: "pointer" }}
        >
          <div className={styles.supplier}>
            <HiUser className={styles.supplierIcon} size={26} />
            <div>
              <p className={styles.infoLabelSupp}>
                {selectedSupplier ? selectedSupplier.name : "Выбрать поставщика"}
              </p>
            </div>
          </div>
        </div>

        <SupplierModal
          isOpen={isSupplierModalOpen}
          onClose={() => setIsSupplierModalOpen(false)}
          onSelect={(supplier) => setSelectedSupplier(supplier)}
        />

        <div className={styles.infoCard}>
          <p className={styles.infoLabel}>Итого к оплате</p>
          <p className={styles.totalPrice}>{totalPrice.toLocaleString()} ₸</p>
        </div>
      </div>

      {/* --- Поиск товара --- */}
      <div className={styles.searchWrapper}>
        <input
          type="search"
          placeholder="Поиск товара по названию или штрихкоду"
          className={styles.search}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onFocus={() => setShowSuggestions(true)}
        />

        <button className={styles.finishBtn} onClick={handleFinishClick}>Завершить</button>
       {isFinishModalOpen && (
          <div className={styles.finishModalOverlay}>
            <div className={styles.finishModal}>
              <span
                className={styles.finishModalClose}
                onClick={() => setIsFinishModalOpen(false)}
              >
                &times;
              </span>

              <h3>Завершение возврата</h3>

              <label>Выберите кошелек</label>
              <CustomSelect
                className={styles.filters__select}
                options={wallets} // уже с правильными label и value
                value={selectedWallet?.id || ""}
                onChange={(val) => {
                  const wallet = wallets.find(w => w.value === val);
                  setSelectedWallet(wallet ? { id: wallet.value } : null);
                }}
                placeholder="Средство для оплаты"
              />

              <label>Комментарий</label>
              <textarea
                placeholder="Напишите комментарий..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />

              <div className={styles.finishModalButtons}>
                <button onClick={submitReturn} disabled={isSubmitting || !selectedWallet}>
                  {isSubmitting ? "Отправка..." : "Отправить"}
                </button>
                <button onClick={() => setIsFinishModalOpen(false)}>Отмена</button>
              </div>
            </div>
          </div>
        )}



        {showSuggestions && suggestions.length > 0 && (
          <div className={styles.searchResults}>
            {suggestions.map((item) => (
              <div
                key={item.product_id}
                className={styles.searchItem}
                onClick={() => handleSelect(item)}
              >
                <span className={styles.productName}>{item.name_ru}</span>
                <span className={styles.productBarcode}>{item.ntin}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* --- Таблица товаров --- */}
      <table className={styles.table}>
        <thead>
          <tr>
            <th>№</th>
            <th>Название</th>
            <th>Штрихкод</th>
            <th>Остаток</th>
            <th>Кол-во</th>
            <th>Ед.</th>
            <th>Цена закупки</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {tableRows.map((row, index) => (
            <tr key={row.product_id}>
              <td>{index + 1}</td>
              <td>{row.name_ru}</td>
              <td>{row.ntin}</td>
              <td>{row.stockQuantity}</td>
              <td>
                <div className={styles.quantityWrapper}>
                  <button
                    className={styles.quantityBtn}
                    onClick={() =>
                      handleQuantityChange(
                        row.product_id,
                        Math.max(0, row.quantity - 1)
                      )
                    }
                  >
                    -
                  </button>
                  <input
                    type="number"
                    min={0}
                    max={row.stockQuantity}
                    value={row.quantity}
                    onChange={(e) => {
                      let value = Number(e.target.value);
                      if (value < 0) value = 0;
                      if (value > row.stockQuantity) value = row.stockQuantity;
                      handleQuantityChange(row.product_id, value);
                    }}
                    className={styles.quantityInput}
                  />
                  <button
                    className={styles.quantityBtn}
                    onClick={() =>
                      handleQuantityChange(
                        row.product_id,
                        Math.min(row.stockQuantity, row.quantity + 1)
                      )
                    }
                  >
                    +
                  </button>
                </div>
              </td>

              <td>------</td>
              <td>{row.purchase_price.toLocaleString()} ₸</td>
              <td className={styles.deleteIcon} onClick={() => removeRow(row.product_id)}>
                <FiTrash2 size={18} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReturnCreatePanel;
